import script from "./AppBidInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppBidInput.vue?vue&type=script&setup=true&lang=ts"

import "./AppBidInput.vue?vue&type=style&index=0&id=83237f9c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83237f9c"]])

export default __exports__